import { render, staticRenderFns } from "./Verlaboratorio.vue?vue&type=template&id=7101582b&scoped=true"
import script from "./Verlaboratorio.vue?vue&type=script&lang=js"
export * from "./Verlaboratorio.vue?vue&type=script&lang=js"
import style0 from "./Verlaboratorio.vue?vue&type=style&index=0&id=7101582b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7101582b",
  null
  
)

export default component.exports